import type { ReactNode } from "react";
import type { OpenExternalUrl } from "../lib/map-link";

/**
 * Google マップを開くリンク。
 * LIFF 内ブラウザでは `target="_blank"` だけでは外部に出られないため、
 * platform (`liff.openWindow({ external: true })`) が渡されていれば既定動作を止めてそちらに委ねる。
 * 通常のブラウザ (LIFF 外 / E2E) では素の別タブ遷移にフォールバックする。
 */
export function MapLink({
  url,
  openExternalUrl,
  className,
  ariaLabel,
  children,
}: {
  url: string;
  openExternalUrl?: OpenExternalUrl;
  className?: string;
  ariaLabel?: string;
  children: ReactNode;
}) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
      className={className}
      onClick={(event) => {
        if (!openExternalUrl) return;
        event.preventDefault();
        openExternalUrl(url);
      }}
    >
      {children}
    </a>
  );
}
